module.exports = __webpack_public_path__ + "img/20.5e7f3e6d.png";